// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080706/js/" + chunkId + "." + {"44":"30aa8792","225":"da15b81c","481":"cea66e20","486":"cf1c3d02","770":"d59fa75b"}[chunkId] + ".0.06468290255438858.chunk.js";
};